import React, { useEffect, useState } from 'react'
import { Col, Container, Form, Input, Label, Row } from 'reactstrap'
import NavBar from '../../components/Navbar'
import "./styles.css"
import { useLocation, useNavigate } from 'react-router-dom'
import { IJob, jobsDummy } from '../../data/jobs'
import { useFormik } from "formik"
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CustomButton from '../../components/CustomButton'
import { useAppDispatch, useAppSelector } from "../../redux/store"
import * as Yup from "yup"
import { sendApplication } from '../../redux/slices/jobSlice'
import useWindowSize from '../../utils/useWindowSize'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify';

export default function Application() {

    const dispatch = useAppDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [thisJob, setThisJob] = useState<undefined | IJob>(undefined)

    const [isLoading, setIsLoading] = useState(false)

    const [width_] = useWindowSize()

    const { i18n, t } = useTranslation()

    useEffect(() => {
        const id = location.pathname.split("/")[2]
        const job = jobsDummy[parseInt(id) - 1]
        setThisJob(job)
        setFileError("")
        setIsLoading(false)
    }, [])

    // useEffect(() => {
    //     if (isFullfilled) {
    //         setIsLoading(false)
    //         dispatch(setFullfilled())
    //     }
    // }, [isFullfilled])

    const [file, setFile] = useState<File | null>(null)
    const [fileString, setFileString] = useState("")

    const [fileError, setFileError] = useState("")


    useEffect(() => {
        if (!file?.name.endsWith('.pdf') && file) {
            toast.error('Yalnızca PDF dosyası yükleyebilirsiniz.');
        } else {
            if (file) {
                convert2base64(file)
            }
            else {
                setFileString("")
                setFile(null)
            }
        }


    }, [file])


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            nameSurname: "",
            email: "",
            gsm: "",
            location: "",
            description: "",
        },
        validationSchema: Yup.object({

            nameSurname: Yup.string().required(),
            email: Yup.string().email().required(),
            gsm: Yup.string().required(),
            location: Yup.string().required(),
            description: Yup.string(),
        }),
        onSubmit: async (values) => {
            console.log(fileString)
            if (file === null || fileString === "") setFileError(i18n.language === "tr" ? "Cv zorunludur." : "Resume is mendatory")

            else {
                setFileError("")

                const payload = {
                    nameSurname: values.nameSurname,
                    email: values.email,
                    gsm: values.gsm,
                    location: values.location,
                    description: values.description ? values.description : "",
                    file: fileString,
                    jobId: location.pathname.split("/")[location.pathname.split("/").length - 2]
                }
                setIsLoading(true)
                const res = await dispatch(sendApplication(payload))
                console.log(res.type === "job/sendApplication/fulfilled")
                if (res.type === "job/sendApplication/fulfilled") {
                    setIsLoading(false)
                    toast.success('Başvurunuz başarıyla alınmıştır!')
                    setTimeout(() => {
                        navigate(-1)
                    }, 1000);

                }
            }

        }
    })


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFile(file);
        }
    }

    const convert2base64 = (file: File) => {
        const reader = new FileReader()

        reader.onloadend = () => {
            if (reader.result)
                setFileString(reader.result.toString())

        }
        reader.readAsDataURL(file)
    }



    return (
        <div className='application-page'>
            <Container>

                <NavBar />
                <Row className="job-row-area" style={{ paddingBottom: "20px" }}>

                    {thisJob && (
                        <>
                            <div className='job-detail-header'>
                                <h4>{thisJob.title}</h4>
                                <Row className='mb-4'>
                                    <Col>
                                        <h5><BusinessOutlinedIcon className='me-2' />{thisJob.firm}</h5>
                                        <h5><LocationOnOutlinedIcon className='me-2' />{thisJob.location}</h5>
                                    </Col>
                                    <Col>
                                        <h5><AccessTimeOutlinedIcon className='me-2' />{thisJob.jobType}</h5>
                                        <h5><WorkOutlineOutlinedIcon className='me-2' />{thisJob.workType}</h5>
                                    </Col>
                                </Row>

                            </div>
                        </>
                    )}
                    <Form className='application-form' onSubmit={e => {
                        validation.handleSubmit()
                        e.preventDefault()

                        return false
                    }}
                        action='#'
                        style={{ width: width_ < 700 ? "95%" : "50%", fontSize: width_ < 700 ? "16px" : "18px" }}
                    >
                        <Label className='ms-1 mt-2'>{t('name')}<span style={{ color: "red" }}>*</span></Label>
                        <Input
                            name='nameSurname'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.nameSurname || ""}
                            invalid={!!validation.errors.nameSurname && validation.touched.nameSurname}
                        />
                        <Label className='ms-1 mt-4'>E-mail<span style={{ color: "red" }}>*</span></Label>
                        <Input type='email'
                            name='email'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={!!validation.errors.email && validation.touched.email}
                        />
                        <Label className='ms-1 mt-4'>{t('gsm')}<span style={{ color: "red" }}>*</span></Label>
                        <Input
                            name='gsm'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.gsm || ""}
                            invalid={!!validation.errors.gsm && validation.touched.gsm}
                        />

                        <Label className='ms-1 mt-4'>{t('city')}<span style={{ color: "red" }}>*</span></Label>
                        <Input
                            name='location'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.location || ""}
                            invalid={!!validation.errors.location && validation.touched.location}
                        />
                        <Label className='ms-1 mt-4'>{t('description')}</Label>
                        <Input type='textarea'
                            name='description'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description || ""}
                            invalid={!!validation.errors.description && validation.touched.description}
                        />
                        <div className='row ms-1 mt-4 d-flex' style={{ justifyContent: "center" }} >

                            <div className="file-upload">
                                <label className="upload-button me-4">
                                    {t('resume')}<span style={{ color: "red" }}>*</span>
                                    <input type="file" accept='.pdf' onChange={handleFileChange} />
                                </label>
                                <span className="file-name  mt-2">{file === null ? "No file chosen" : fileString ? file.name : "An error occured"}</span>
                            </div>
                            <p style={{ color: "red", textAlign: "center" }}>{fileError}</p>
                            {validation.errors.email ? <p style={{ color: "red", textAlign: "center" }}>{i18n.language === "tr" ? "Lütfen geçerli bir email girin" : "Please enter a valid email"}</p> : Object.keys(validation.errors).length > 0 ? <p style={{ color: "red", textAlign: "center" }}>{i18n.language === "tr" ? "yıldızlı alanlar boş olamaz" : "Marked fields cannot be empty"}</p> : ""}
                            <hr />
                            <CustomButton isLoading={isLoading} className='mt-2 send-button' label={i18n.language === "tr" ? "Gönder" : "Apply"} type="submit" />
                        </div>

                        <div className='d-flex' style={{ justifyContent: "center" }}>


                        </div>
                    </Form>
                </Row>


            </Container >
        </div >
    )
}
